import React from 'react';
import { withTranslation } from 'react-i18next';
import makeStyles from '@mui/styles/makeStyles';
import { Drawer } from '@mui/material';
// share icons and buttons
import { EmailShareButton,FacebookShareButton,LineShareButton,LinkedinShareButton,TelegramShareButton,TwitterShareButton,ViberShareButton,WhatsappShareButton} from "react-share";
import {EmailIcon,FacebookIcon,LineIcon,LinkedinIcon,TwitterIcon,ViberIcon,WhatsappIcon,TelegramIcon} from "react-share";

const useStyles = makeStyles({
    drawer:{
        padding:'10px',
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        flexWrap:'wrap'
    },

    marLeft:{
        marginLeft:'10px'
    },
    marRight:{
        marginRight:'10px'
    }
})

function ShareDrawer(props) {
    const { i18n, open, closeDrawer,link, direction } = props;
    const shareUrl = link ? link : window.location.href;
    const classes = useStyles();
    const isRTL = i18n.translator.language;
    const shareButtons = [
        <div className={isRTL === 'ar' ? classes.marLeft : classes.marRight}>
            <FacebookShareButton url={shareUrl}>
                <FacebookIcon size={40} round={true} />
            </FacebookShareButton>
        </div>,
        <div className={isRTL === 'ar' ? classes.marLeft : classes.marRight}>
            <WhatsappShareButton url={shareUrl}>
                <WhatsappIcon size={40} round={true} />
            </WhatsappShareButton>
        </div>,
        <div className={isRTL === 'ar' ? classes.marLeft : classes.marRight}>
            <TwitterShareButton url={shareUrl}>
                <TwitterIcon size={40} round={true} />
            </TwitterShareButton>
        </div>,
        <div className={isRTL === 'ar' ? classes.marLeft : classes.marRight}>
            <EmailShareButton url={shareUrl}>
                <EmailIcon size={40} round={true} />
            </EmailShareButton>
        </div>,
        <div className={isRTL === 'ar' ? classes.marLeft : classes.marRight}>
            <LinkedinShareButton url={shareUrl}>
                <LinkedinIcon size={40} round={true} />
            </LinkedinShareButton>
        </div>,
        <div className={isRTL === 'ar' ? classes.marLeft : classes.marRight}>
            <ViberShareButton url={shareUrl}>
                <ViberIcon size={40} round={true} />
            </ViberShareButton>
        </div>,
        <div className={isRTL === 'ar' ? classes.marLeft : classes.marRight}>
            <TelegramShareButton url={shareUrl}>
                <TelegramIcon size={40} round={true} />
            </TelegramShareButton>
        </div>,
        <div className={isRTL === 'ar' ? classes.marLeft : classes.marRight}>
            <LineShareButton url={shareUrl}>
                <LineIcon size={40} round={true} />
            </LineShareButton>
        </div>
    ]
    
    return(
        <Drawer
            anchor={direction ? direction : "bottom"}
            open={open}
            onClose={closeDrawer}
        >
            <div dir={isRTL === 'ar' ? 'rtl' : 'ltr'} className={classes.drawer}>
                {React.Children.toArray(shareButtons.map(v=> {
                    return <span>{v}</span>
                }))}
            </div>
        </Drawer>
    )
}

export default withTranslation('common')(ShareDrawer);